import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
const bidComparisonExcelMetadataSchema = z.object({
    sheet_name: z.string(),
    row: z.array(z.number().int()).nullish(),
    col: z.array(z.number().int()).nullish(),
    column_name: z.array(z.string()).nullish(),
});
const bidComparisonCitationSchema = z.object({
    blob_id: z.string(),
    page: z.number().int(),
    label: z.string().optional(),
    // Set when the cited blob lives in a different package than the bids (the
    // tender/reference document); the read URL is fetched against this package.
    document_package_id: z.string().optional(),
    passage: z.string().optional(),
    x0: z.number().optional(),
    y0: z.number().optional(),
    x1: z.number().optional(),
    y1: z.number().optional(),
    // The original blob file name, so the frontend can detect Excel files and
    // open the spreadsheet viewer instead of the PDF viewer.
    file_name: z.string().optional(),
    // Cell coordinates for Excel highlighting (sheet, row, col).
    excel_metadata: bidComparisonExcelMetadataSchema.nullish(),
});
const bidComparisonCellSchema = z.object({
    contractor_id: z.string(),
    value: z.string(),
    // ADDRESSED or PARTIAL — drives the cell's color mark. Optional so a stale
    // payload without it still parses.
    conflict_type: z.string().optional(),
    // The formatted amount when the bid provided a concrete value (number or
    // percentage). Present only when `value` was derived from the amount field.
    amount: z.string().optional(),
    // The verbatim bid extract, carried alongside `value`.
    bid_extract: z.string().optional(),
    // The bid-gaps narrative for the requirement, carried alongside `value`.
    bid_context: z.string().optional(),
    citation: bidComparisonCitationSchema.optional(),
});
const bidComparisonContractorSchema = z.object({
    id: z.string(),
    name: z.string(),
});
const bidComparisonRowSchema = z.object({
    id: z.string(),
    item: z.string(),
    category: z.string(),
    weight: z.number(),
    // AI sort-order priority for the requirement: 1 is the highest priority, 10
    // the lowest, with an unranked requirement defaulted to 10. 11 is the "not
    // comparable" bucket, which the Offer table hides.
    rank: z.number().int(),
    // The tender/requirement source document, opened from the Item column.
    reference: bidComparisonCitationSchema.optional(),
    cells: z.array(bidComparisonCellSchema),
});
export const bidComparisonResponseSchema = z
    .object({
    summary: z.string(),
    bids_compared: z.number().int(),
    items_leveled: z.number().int(),
    total_weighting: z.number(),
    contractors: z.array(bidComparisonContractorSchema),
    rows: z.array(bidComparisonRowSchema),
})
    .strict()
    .transform(mapToCamelCase);
